import moment from 'moment';
import Vue from 'vue';
import Router from 'vue-router';
import TheLayout from './app/TheLayout.vue';
import Login from './app/views/Login.vue';
import Home from './app/views/Home.vue';
import Geocode from './app/views/Geocode.vue';
import GeocodeList from './app/views/GeocodeList.vue';
import SendPointsToGeocoding from './app/views/SendPointsToGeocoding.vue';
import ChangeStatusOrder from './app/views/ChangeStatusOrder.vue';
import ChangeRouteOrigin from './app/views/ChangeRouteOrigin.vue';
import ChangeRouteLocality from './app/views/ChangeRouteLocality.vue';
import Import from './app/views/Import.vue';
import Tracing from './app/views/Tracing.vue';
import TracingEnterprise from './app/views/TracingEnterprise.vue';
import TracingEnterpriseRoute from './app/views/TracingEnterpriseRoute.vue';
import PlanningIndex from './app/views/PlanningIndex.vue';
import PlanningV4 from './app/views/PlanningV4.vue';
import PlanningSimpliroute from './app/views/PlanningSimpliroute.vue';
// import PlanningSts from './app/views/PlanningSts.vue';
import PlanningStsV2 from './app/views/PlanningStsV2.vue';
import PlanningCollaborative from './app/views/PlanningCollaborative.vue';
import PlanningModify from './app/views/PlanningModify.vue';
import PlanningAdmin from './app/views/PlanningAdmin.vue';
import DistributionCenterConfigs from './app/views/DistributionCenterConfigs.vue';
import UserList from './app/views/user/List.vue';
import UserChangePass from './app/views/user/ChangePass.vue';
import UserRegister from './app/views/user/Register.vue';
import Queues from './app/views/Queues.vue';
import Reporter from './app/views/Reporter.vue';
import ReporterSupervisarOnly from './app/views/ReporterSupervisarOnly.vue';
import ReporterGeo from './app/views/ReporterGeo.vue';
import { clearRumUserContext } from '@/observability/datadogRum';
import PlanningEditRoutes from './app/components/PlanningEditRoutes.vue'; // Routes
import PlanningEditRoutesV2 from './app/views/PlanningEditRoutesV2.vue'; // Routes v2
import TestGeo from './app/views/TestGeo.vue';
import ZonesModify from './app/views/ZonesModify.vue';
import ZonesPriority from './app/views/ZonesPriority.vue';
// import PlanningEdit from './app/views/PlanningEdit.vue';
// import PlanningActivate from './app/views/PlanningActivate.vue';
import TracingV1 from './app/views/TracingV1.vue';
import TracingEnterpriseV1 from './app/views/TracingEnterpriseV1.vue';
import { decodeRSA } from './mixins/function';
// eslint-disable-next-line import/named
import { retriveSession } from './mixins/manageSession';
import Routes from './app/views/Routes.vue';
import Suborder from './app/views/Suborder.vue';
import PlanningStatus from './app/views/PlanningStatus.vue';
// import Zones from './app/views/Zones.vue';
import Vehicles from './app/views/Vehicles.vue';
import ImportPoints from './app/views/import/Points.vue';

Vue.use(Router);

const restrictRoutesChildren = [
  {
    groups: ['1', '2'],
    path: 'geocode',
    name: 'Geocode',
    component: Geocode,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'geocodeList',
    name: 'GeocodeList',
    component: GeocodeList,
    props: true,
  },
  {
    groups: ['1'],
    path: 'ChangeStatusOrder',
    name: 'ChangeStatusOrder',
    component: ChangeStatusOrder,
    props: true,
  },
  {
    groups: ['1'],
    path: 'changeRouteOrigin',
    name: 'ChangeRouteOrigin',
    component: ChangeRouteOrigin,
    props: true,
  },
  {
    groups: ['1'],
    path: 'changeRouteLocality',
    name: 'ChangeRouteLocality',
    component: ChangeRouteLocality,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'SendPointsToGeocoding',
    name: 'SendPointsToGeocoding',
    component: SendPointsToGeocoding,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'ImportPoints',
    name: 'ImportPoints',
    component: ImportPoints,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'import',
    name: 'Import',
    component: Import,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'planning',
    name: 'planning',
    component: PlanningIndex,
  },
  {
    groups: ['1', '2'],
    path: 'planningv4',
    name: 'PlanningV4',
    component: PlanningV4,
  },
  {
    groups: ['1', '2'],
    path: 'planningSimpliroute',
    name: 'PlanningSimpliroute',
    component: PlanningSimpliroute,
  },
  {
    groups: ['1', '2'],
    path: 'collaborative',
    name: 'collaborative',
    component: PlanningCollaborative,
  },
  // {
  //   groups: ['1', '2'],
  //   path: 'planning-sts',
  //   name: 'planning-sts',
  //   component: PlanningStsV2,
  // },
  {
    groups: ['1', '2'],
    path: 'admin',
    name: 'admin',
    component: PlanningAdmin,
  },
  {
    groups: ['1'],
    path: 'distribution-center-configs',
    name: 'DistributionCenterConfigs',
    component: DistributionCenterConfigs,
  },
  {
    groups: ['1', '2'],
    path: 'status',
    name: 'Status',
    component: PlanningStatus,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'modify',
    name: 'modify',
    component: PlanningModify,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'editPlanning/:idTracing',
    name: 'editPlanning',
    component: PlanningEditRoutes,
    props: true,
  },
  // Edit Planning v2
  {
    groups: ['1', '2'],
    path: 'editMultiple/:idTracing',
    name: 'editMultiple',
    component: PlanningEditRoutesV2,
    props: true,
  },
  {
    groups: ['1', '2', '3', '5', '6'],
    path: 'tracingV1',
    name: 'TracingV1',
    component: TracingV1,
  },
  {
    groups: [],
    path: 'tracing',
    name: 'Tracing',
    component: Tracing,
  },
  {
    groups: [],
    path: 'tracingEnterprise',
    name: 'TracingEnterprise',
    component: TracingEnterprise,
  },
  {
    groups: ['1'],
    path: 'testgeo',
    name: 'TestGeo',
    component: TestGeo,
  },
  {
    groups: ['1'],
    path: 'tracingEnterpriseV1',
    name: 'TracingEnterpriseV1',
    component: TracingEnterpriseV1,
  },
  {
    groups: ['1'],
    path: 'tracingEnterprise/:patent',
    name: 'TracingEnterpriseRoute',
    component: TracingEnterpriseRoute,
  },
  {
    groups: ['1', '2', '3', '6'],
    path: 'zonesmodify',
    name: 'ZonesModify',
    component: ZonesModify,
  },
  {
    groups: ['1', '2', '3', '6'],
    path: 'zonespriority',
    name: 'ZonesPriority',
    component: ZonesPriority,
  },
  {
    groups: ['1', '2'],
    path: 'suborder',
    name: 'Suborder',
    component: Suborder,
    props: true,
  },
  {
    groups: ['1', '2', '3', '6'],
    path: 'reporter',
    name: 'Reporter',
    component: Reporter,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'reporterGeo',
    name: 'ReporterGeo',
    component: ReporterGeo,
    props: true,
  },
  {
    groups: ['5'],
    path: 'reporterSupOnly',
    name: 'ReporterSupervisorOnly',
    component: ReporterSupervisarOnly,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'routes',
    name: 'Routes',
    component: Routes,
    props: true,
  },
  {
    groups: ['1'],
    path: 'userList',
    name: 'UserList',
    component: UserList,
    props: true,
  },
  {
    groups: ['1'],
    path: 'userChangePass',
    name: 'UserChangePass',
    component: UserChangePass,
    props: true,
  },
  {
    groups: ['1'],
    path: 'userRegister',
    name: 'UserRegister',
    component: UserRegister,
    props: true,
  },
  {
    groups: ['1', '2'],
    path: 'queues',
    name: 'Queues',
    component: Queues,
    props: true,
  },
  {
    groups: ['1', '2', '3'],
    path: 'vehicles',
    name: 'Vehicles',
    component: Vehicles,
  },
];

const r = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'Login' },
      component: TheLayout,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
        },
        {
          path: 'home',
          name: 'Home',
          component: Home,
        },
      ],
    },
    {
      path: '/app',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: TheLayout,
      children: restrictRoutesChildren,
    },
  ],
});

r.beforeResolve((to, from, next) => {
  const now = moment.now();
  const diff = Math
    .ceil(moment(sessionStorage.getItem('expire_token')).diff(now)) / 60000;
  retriveSession();
  if (to.path !== '/login') {
    if (diff > 0) {
      if (to.path.startsWith('/app')) {
        const tienePermiso = restrictRoutesChildren
          .filter(child => child.groups.indexOf(decodeRSA(sessionStorage.type)) >= 0);
        if (tienePermiso.filter(child => child.name === to.name).length > 0) {
          if (to.name === 'ImportPoints' && decodeRSA(sessionStorage.country) !== 'PE') {
            r.replace('home');
          } else {
            next();
          }
        } else {
          r.replace('home');
        }
      } else {
        next();
      }
    } else {
      clearRumUserContext();
      sessionStorage.clear();
      r.replace({
        path: 'login',
        query: { redirect: to.fullPath },
      });
    }
  } else if (diff > 0) {
    r.replace('home');
  } else {
    next();
  }
});

export default r;
